import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
import { forYouPoints } from '../../data/forYou';
export function ForYou() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-87" data-mp="2tasppah0r7b5">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-88" data-mp="3gzbydr3zdm3r">
        <SectionTag icon="👀" data-id="element-89" data-mp="3h03ia4o7tve7">Esto es para ti si…</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-ink sm:text-4xl" data-id="element-90" data-mp="3l170gxtqk3il">
          ¿Te suena alguna de estas escenas?
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-91" data-mp="3c08re14fx5t5">
          Si te identificas con 2 o más, EF-FLASH fue diseñada exactamente para ti.
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-92" data-mp="1vobvwf7hvbu5">
        {forYouPoints.map((point, i) => <m.div key={point.n} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="relative flex flex-col rounded-2xl border border-slate-200 bg-bg-secondary p-6" data-id="element-93" data-mp="3p8sg19s9fsm3" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-94" data-mp="3uaztk3sqngqj">
              <span className="font-heading text-3xl font-bold text-ink/10" data-id="element-95" data-mp="c1h6qu627mv5">{point.n}</span>
              <span className="text-2xl" aria-hidden="true" data-id="element-96" data-mp="80nhnxgvs20o">
                {point.emoji}
              </span>
            </div>
            <span className="mt-3 inline-block w-fit rounded-full bg-flash/10 px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wide text-flash" data-id="element-97" data-mp="luxzduugmvx8">
              {point.tag}
            </span>
            <h3 className="mt-3 font-heading text-base font-bold leading-snug text-ink" data-id="element-98" data-mp="vowzkoaz45mj">{point.title}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-muted" data-id="element-99" data-mp="qptvp76qc5g5">{point.text}</p>
            <div className="mt-4 flex h-6 w-6 items-center justify-center rounded-full bg-success/10" data-id="element-100" data-mp="xwxvac0wp35r">
              <CheckIcon size={14} className="text-success" data-id="element-101" data-mp="12s4wnd6pdvri" />
            </div>
          </m.div>)}
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 text-center sm:px-6" data-id="element-102" data-mp="1ck0ucn4vnjv7">
        <p className="text-base leading-relaxed text-ink sm:text-lg" data-id="element-103" data-mp="1clbzaqa26xnw">
          Entra al patio con la seguridad de quien lleva todo listo, justificado y listo para observar
          realmente.
        </p>
        <div className="mt-6 flex justify-center" data-id="element-104" data-mp="1lmsah08p73t6">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-105" data-mp="1qjiprlcohvdj">Quiero EDUCACIÓN FÍSICA FLASH</PrimaryButton>
        </div>
      </div>
    </section>;
}